import type Phaser from "phaser";

export function prefersReducedMotion(): boolean {
  try {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  } catch {
    return false;
  }
}

export const COLORS = {
  cream: "#f3e6c8",
  ink: "#2a1a10",
  moss: "#1f3d2b",
  honey: "#e8b84a",
  bark: "#5c3a1e",
  berry: "#c44536",
};

export const FONTS = {
  display: "Fredoka, Nunito, sans-serif",
  body: "Nunito, Trebuchet MS, sans-serif",
  /** Heavy slab used for the painted Hibernation Run logo letters. */
  wood: '"Alfa Slab One", Rockwell, serif',
};

export function titleStyle(size = 42): Phaser.Types.GameObjects.Text.TextStyle {
  return {
    fontFamily: FONTS.display,
    fontSize: `${size}px`,
    color: COLORS.cream,
    stroke: COLORS.ink,
    strokeThickness: 6,
    align: "center",
  };
}

export function bodyStyle(size = 22): Phaser.Types.GameObjects.Text.TextStyle {
  return {
    fontFamily: FONTS.body,
    fontSize: `${size}px`,
    color: COLORS.ink,
    align: "center",
    wordWrap: { width: 640 },
  };
}

export function hudStyle(size = 28): Phaser.Types.GameObjects.Text.TextStyle {
  return {
    fontFamily: FONTS.display,
    fontSize: `${size}px`,
    color: COLORS.cream,
    stroke: COLORS.ink,
    strokeThickness: 5,
  };
}
